export default "__VITE_ASSET__BnRmko0z__"